import { MemreRTE } from 'components/core';

export default function TextBlock({ item }) {
  return (
    <MemreRTE id="123" initialContent={item.text} placeholder="Type your content here..." onUpdate={item.updateText} />
  );
}
